
export interface TestInmunoDTO {
  id: string
  patientID: string
  createdAt: Date
  pdf?: string
  kit?: string
  hla?: string
  rhd?: string
  abo?: string
  result?: string
}

export class TestInmuno {
  private _id: string
  private _patientID: string
  private _createdAt: Date
  private _pdf?: string
  private _kit?: string
  private _hla?: string
  private _rhd?: string
  private _abo?: string
  private _result?: string
  

  constructor(p: TestInmunoDTO) {
    this._id = p.id
    this._patientID = p.patientID
    this._createdAt = p.createdAt
    this._pdf = p.pdf
    this._kit = p.kit
    this._hla = p.hla
    this._rhd = p.rhd
    this._abo = p.abo 
    this._result = p.result
  }

  get id(): string {
    return this._id
  }

  set id(value: string) {
    this._id = value
  }

  get patientID(): string {
    return this._patientID
  }

  set patientID(value: string) {
    this._patientID = value
  }

  get createdAt(): Date {
    return this._createdAt
  }

  set createdAt(value: Date) {
    this._createdAt = value
  }

  get pdf(): string | undefined {
    return this._pdf
  }

  set pdf(value: string | undefined) {
    this._pdf = value
  }

  get result(): string | undefined {
    return this._result
  }

  set result(value: string | undefined) {
    this._result = value;
  }
  
  get kit() {
    return this._kit
  }
  get hla() {
    return this._hla
  }
  get rhd() {
    return this._rhd
  }
  get abo() {
    return this._abo
  }



  toDTO(): TestInmunoDTO {
    return {
      id: this.id,
      patientID: this.patientID,
      createdAt: this.createdAt,
      pdf: this.pdf,
      kit: this.kit,
      hla: this.hla,
      rhd: this.rhd,
      abo: this.abo,
      result: this.result,
    }
  }
}

export function toModel(d: TestInmunoDTO): TestInmuno {
  return new TestInmuno(d)
}
